import { render, staticRenderFns } from "./add-audio-group-modal.vue?vue&type=template&id=7c746f52&scoped=true"
import script from "./add-audio-group-modal.vue?vue&type=script&lang=ts"
export * from "./add-audio-group-modal.vue?vue&type=script&lang=ts"
import style0 from "./add-audio-group-modal.vue?vue&type=style&index=0&id=7c746f52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c746f52",
  null
  
)

export default component.exports